<template>
  <div>
    <el-table id="codingLargeStatQm" :data="dashboardData.length ? dashboardData[0].largeStats[9].data : []" empty-text="No QM Data Available" :fit="true"
      :height="isModal ? null : '265'" show-summary :summary-method="getSummary">
      <el-table-column prop="shortDescription" label="Description" sortable>
        <template slot-scope="scope">
          <el-popover popper-class="qmPopover" placement="bottom" title="CMS.gov QualityNet" width="360" trigger="click">
            <a href="https://www.qualitynet.org/inpatient/measures/mortality/methodology" target="_blank">
              <el-button size="mini" type="primary">Mortality Methodology</el-button>
            </a>
            <a style="margin-left: 10px;" href="https://www.qualitynet.org/inpatient/measures/readmission/methodology" target="_blank">
              <el-button size="mini" type="primary">Readmission Methodology</el-button>
            </a>
            <span style="color: #337ab7;cursor: pointer;display: block; text-decoration: none;" slot="reference">{{scope.row.shortDescription}}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="mortalityCount" label="Mortality" width="100" sortable>
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.shortDescription} Records`, scope.row.mortalityAccounts, $event)">
            {{scope.row.mortalityCount}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="readmissionCount" label="Readmission" width="100" sortable>
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.shortDescription} Records`, scope.row.readmissionAccounts, $event)">
            {{scope.row.readmissionCount}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="qmCount" label="Total Records" width="100" sortable>
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.shortDescription} Records`, scope.row.accounts, $event)">
            {{scope.row.qmCount}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="qmDisclaimer">The above analysis represents potential CMS Mortality and Readmission
      Quality Measure triggers. Actual readmission and mortality data is not able to be calculated based
      on limited data.</div>
  </div>
</template>

<script>
  import money from '@/mixins/money'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
    },
    data: function () {
      return {
      }
    },
    name: 'QualityMeasuresTable',
    methods: {
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      emitDetailsEvent(title, accounts, e) {
        this.$emit('detailsClick', {
          title: title,
          accounts: accounts,
          e: e
        })
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const mortalityCount = this.totalSummary('mortalityCount', param.data)
        const readmissionCount = this.totalSummary('readmissionCount', param.data)
        const qmCount = this.totalSummary('qmCount', param.data)

        return [null, mortalityCount, readmissionCount, qmCount]
      }
    },
    created: function () {
    },
    mounted: function () {
      this.$nextTick(() => {
        const footerRow = document.querySelectorAll('#codingLargeStatQm table.el-table__footer td')
        const td = footerRow[footerRow.length - 1]
        td.classList.add('dottedUnderline')
        td.addEventListener('click', (e) => {
          const allAccounts = this.dashboardData[0].largeStats[9].data.map(x => x.accounts).join(',')
          this.emitDetailsEvent('All QM Records', allAccounts, e)
        })
      })
    },
    computed: {
      isModal() {
        return this.$parent.modal
      }
    }
  }
</script>

<style scoped>
  .qmDisclaimer {
    font-size: 10px;
    font-style: italic;
    margin: 5px 0px 0px 0px;
    color: #909399;
  }
</style>
